import BaseService from "./BaseService";

export default class ExchanageRateService extends BaseService {

    public static getExchangeRate(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/get-currency-pair`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }


    public static getFromCurrency(token: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/get-from-currency-list`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        })
    }


    public static getToCurrency(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/get-to-currency-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }


    public static addCurrencyPairs(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/add-currency-pair`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateCurrencyPairRates(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/edit-currency-pair`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateCurrencyPairStatus(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}currency/update-currency-pair-status`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getRecipientCountryList(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'recipient/country-lists/v2', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },

        })
    }

    public static getSenderCountryList(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'recipient/sender-country-lists', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },

        })
    }

    public static updatePaymentMethod(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/update-payment-method`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}